import { MessageInstance } from 'antd/es/message/interface';

let messageApi: MessageInstance | null = null;

export const setMessageApi = (api: MessageInstance) => {
  messageApi = api;
};

export const showMessage = (type: 'error' | 'success' | 'info' | 'warning' | 'loading', content: string) => {
  if (messageApi) {
    messageApi.open({
      type,
      content: <div dangerouslySetInnerHTML={{ __html: content }} />,
    });
  } else {
    console.warn('messageApi is not initialized. Please call setMessageApi() inside a React component.');
  }
};